import { render, staticRenderFns } from "./CompanyUpdateUserAccess.vue?vue&type=template&id=6c937aec"
import script from "./CompanyUpdateUserAccess.vue?vue&type=script&lang=js"
export * from "./CompanyUpdateUserAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports